import { render, staticRenderFns } from "./TrendChartDemo.vue?vue&type=template&id=6382317a&"
import script from "./TrendChartDemo.vue?vue&type=script&lang=js&"
export * from "./TrendChartDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports